import omit from 'lodash.omit';

import { ModelConceptAttribute } from 'src/containers/ProjectDiagram/types/data';
import { Model, ModelData } from 'src/containers/ProjectDiagram/types/model';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export const removeDomainFromAllAttributesData =
  (domain: string) => (model: Model) => {
    const newAttributesByIri = Object.values(
      model.modelData.attributesByIri
    ).reduce<Record<string, ModelConceptAttribute>>((acc, attribute) => {
      acc[attribute.value] = {
        ...attribute,
        domains: omit(attribute.domains, domain),
      };
      return acc;
    }, {});

    setDataProperty<ModelData>(model)(
      model.modelData,
      'attributesByIri',
      newAttributesByIri
    );
  };
